import { getAnalytics, logEvent, isSupported } from "firebase/analytics";
import { app } from '../firebase-config';  // Adjust this path to your Firebase config
import posthog from 'posthog-js';

let analytics = null;

// Initialize analytics only if supported
const initializeAnalytics = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized successfully');
    } else {
      console.log('Firebase Analytics not supported in this environment');
    }
  } catch (error) {
    console.warn('Firebase Analytics initialization failed:', error);
  }
};

// Initialize analytics
initializeAnalytics();

export const trackPageView = (path) => {
  // Firebase Analytics
  if (analytics) {
    try {
      logEvent(analytics, 'page_view', {
        page_path: path,
        page_title: document.title
      });
      console.log('Firebase page view tracked:', path);
    } catch (error) {
      console.error('Error tracking Firebase page view:', error);
    }
  }
  
  // PostHog Analytics
  try {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      page_path: path,
      page_title: document.title
    });
    console.log('PostHog page view tracked:', path);
  } catch (error) {
    console.error('Error tracking PostHog page view:', error);
  }
};

export const trackEvent = (eventName, properties = {}) => {
  // Firebase Analytics
  if (analytics) {
    try {
      logEvent(analytics, eventName, {
        ...properties,
        timestamp: new Date().toISOString()
      });
      console.log('Firebase event tracked:', eventName, properties);
    } catch (error) {
      console.error('Error tracking Firebase event:', error);
    }
  }
  
  // PostHog Analytics
  try {
    posthog.capture(eventName, {
      ...properties,
      timestamp: new Date().toISOString()
    });
    console.log('PostHog event tracked:', eventName, properties);
  } catch (error) {
    console.error('Error tracking PostHog event:', error);
  }
};

// PostHog specific functions
export const identifyUser = (userId, userProperties = {}) => {
  try {
    posthog.identify(userId, userProperties);
    console.log('PostHog user identified:', userId, userProperties);
  } catch (error) {
    console.error('Error identifying user in PostHog:', error);
  }
};

export const testPostHog = () => {
  try {
    posthog.capture('posthog_test_event', {
      test: true,
      timestamp: new Date().toISOString(),
      page: window.location.pathname
    });
    console.log('PostHog test event sent successfully!');
    return true;
  } catch (error) {
    console.error('PostHog test event failed:', error);
    return false;
  }
};

export default analytics;